import React from "react";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";

const LinkLogo = ({ linkLogo, width }) => {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      {linkLogo.map((item, index) => (
        <Box
          key={index}
          component={Link}
          to={item.link}
          sx={{
            marginLeft: "10px",
          }}
        >
          <item.LinkLogoSvg width={width} />
        </Box>
      ))}
    </Box>
  );
};

export default LinkLogo;
